const conf = {
  // serverUrl: window?.location?.hostname === "SAWARI" ? 'https://service.SAWARI' : 'http://103.125.216.56:8097',
  serverUrl: 'https://service.sawari.lk',
  // serverUrl: 'https://0414255a82de.ngrok-free.app',
  // serverUrl: 'http://103.125.216.56:8097',
  // serverUrl: '',
  basePath: 'api/v1',
  port: 80
};

export default conf;
